module.exports = __webpack_public_path__ + "img/img23.758e786c.jpg";